import { TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import usePlanStore from '../../../../../../store/planStore';

export default function CampaignCodeInput() {
  const { t } = useTranslation();
  const { generalInfoState, setGeneralInfoState, savedGeneralInfoState } =
    usePlanStore((state) => ({
      generalInfoState: state.generalInfoState,
      savedGeneralInfoState: state.savedGeneralInfoState,
      setGeneralInfoState: state.setGeneralInfoState,
    }));

  const { id } = useParams();

  const { campaignCode } = generalInfoState;

  const isTooLong = campaignCode?.length > 4;
  const isInvalidFormat =
    (id && !campaignCode) ||
    (id && campaignCode?.length === 0) ||
    (campaignCode?.length > 0 && !/^#[0-9]{3}$/.test(campaignCode));

  let campaignHelperText =
    'Use #999 for Campaign Code if you want to validate your campaign idea';

  if (isInvalidFormat || isTooLong) {
    campaignHelperText = t('Campaign Code format: # followed by 3 digits');
  }

  return (
    <Controller
      name="campaignCode"
      render={({ field }) => (
        <TextField
          {...field}
          label={t('Campaign Code')}
          variant="outlined"
          value={generalInfoState.campaignCode}
          fullWidth
          error={isInvalidFormat || generalInfoState.campaignCode?.length > 4}
          helperText={campaignHelperText}
          placeholder="#000"
          onChange={(event) => {
            setGeneralInfoState({
              campaignCode: event.target.value,
            });
          }}
        />
      )}
    />
  );
}
